/**
 * Dynamically resolves the API base URL.
 * If VITE_APP_API_URL contains 'localhost' or '127.0.0.1' and the app is accessed
 * from a mobile device or remote host via IP address/domain, automatically replaces
 * 'localhost' with window.location.hostname so fetch calls succeed on mobile.
 */
export const getApiUrl = () => {
  let url = import.meta.env.VITE_APP_API_URL || 'http://localhost/apiajis/public/api';
  if (
    typeof window !== 'undefined' &&
    window.location.hostname &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
  ) {
    url = url.replace('localhost', window.location.hostname).replace('127.0.0.1', window.location.hostname);
  }
  return url;
};

/**
 * Dynamically resolves the image assets URL for logos and attachments.
 */
export const getImageUrl = (filename) => {
  if (!filename) return '';
  if (filename.startsWith('http://') || filename.startsWith('https://') || filename.startsWith('data:')) {
    return filename;
  }
  let base = import.meta.env.VITE_APP_IMAGE_URL;
  if (!base) {
    let api = getApiUrl();
    base = api.replace(/\/api\/?$/, '/assets/img/').replace(/\/public\/api\/?$/, '/public/assets/img/');
  } else if (
    typeof window !== 'undefined' &&
    window.location.hostname &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
  ) {
    base = base.replace('localhost', window.location.hostname).replace('127.0.0.1', window.location.hostname);
  }
  if (!base.endsWith('/')) base += '/';
  return base + filename;
};

/**
 * Fetches an image URL and converts it into a Base64 Data URL
 * to ensure 100% synchronous rendering in PDF print windows.
 */
export const fetchImageAsBase64 = async (url) => {
  if (!url) return '';
  if (url.startsWith('data:')) return url;
  try {
    const res = await fetch(url);
    if (!res.ok) return url;
    const blob = await res.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => resolve(url);
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    return url;
  }
};

export default getApiUrl;
